/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import {
  createQuantity,
  createQuantityComparator,
  createQuantityMapper,
  decimalToFoot,
  footToDecimal,
} from '@gh/core-data';
import { GtoUom } from '../take-off-params';

export const UomQuantityMapper = createQuantityMapper({
  [GtoUom.Feets]: footToDecimal,
});

export const createUomQuantity = (value: number, uomCode: string) =>
  GtoUom.Feets === uomCode ? createQuantity(decimalToFoot(value), uomCode) : createQuantity(value, uomCode);

export const uomQuantityComparator = createQuantityComparator({
  [GtoUom.Feets]: (q) => footToDecimal(q.value),
});
